export default function activeConversationReducer (state = null, action) {
  switch (action.type) {
    case 'SET_ACTIVE_CONVERSATION':
      return action.payload;
    default:
      return state;
  }
};